import ItemDetailImage from '../ItemDetailImage';

export default class QuestRewardDetail extends ItemDetailImage {

    constructor(props) {
        super(props);

        const {item} = this.props;

        this.property = item.QuestRewards;

        if(!this.property) {
            return;
        }

        this.singleItemUrl = `/quests/${this.property[0].QuestId}`;
        this.multipleItemUrl = `/quests?reward=${item.ItemKey}`;

        this.singleItemContent = this.property[0].ShortDescription ? this.property[0].ShortDescription.English : ''
        this.multipleItemContent = `This item is the reward from ${this.property.length} different quests`;

        this.header = this.property[0].Name.English;
    }

    get icon() {
        return 'check-circle';
    }
}


// WEBPACK FOOTER //
// ./src/items/index/item-detail-components/QuestRewardDetail.jsx